import React, { useState } from 'react';
import {
  LuSmartphone,
  LuMegaphone,
  LuGlobe,
  LuArrowRight,
  LuStar,
  LuGift,
  LuUsers,
  LuClipboardCheck,
  LuTarget,
  LuArrowUpRight,
  LuArrowDownRight,
} from 'react-icons/lu';
import { FaFacebook, FaGoogle } from 'react-icons/fa6';

// Konstanta WhatsApp
const WA_NUMBER = '6282337289588';

const TABS = [
  { key: 'sosmed', label: 'Kelola Sosmed', icon: LuSmartphone },
  { key: 'meta', label: 'Meta Ads', icon: LuMegaphone },
  { key: 'landing', label: 'Landing Page', icon: LuGlobe },
];

const PLANS = [
  {
    name: 'Paket Siji',
    subtitle: 'Facebook & Instagram Ads',
    price: 'Rp490.000',
    popular: false,
    features: [
      'Budget Ads: Rp50.000/hari',
      'Durasi: 7 hari',
      'Estimasi reach: 14.700–42.700 akun',
    ],
  },
  {
    name: 'Paket Loro',
    subtitle: 'Facebook & Instagram Ads',
    price: 'Rp990.000',
    popular: false,
    features: [
      'Budget Ads: Rp50.000/hari',
      'Durasi: 14 hari',
      'Estimasi reach: 29.400–85.400 akun',
      'Free 1 Desain + Caption',
    ],
  },
  {
    name: 'Paket Telu',
    subtitle: 'Facebook & Instagram Ads',
    price: 'Rp1.990.000',
    popular: true,
    features: [
      'Budget Ads: Rp50.000/hari',
      'Durasi: 30 hari',
      'Estimasi reach: 63.000–183.000 akun',
      'Free 1 Desain + Caption',
    ],
  },
  {
    name: 'Paket Papat',
    subtitle: 'Facebook & Instagram Ads',
    price: 'Rp5.000.000+',
    popular: false,
    features: [
      'Budget Ads: Sesuai Kebutuhan',
      'Durasi: 30 hari+',
      'Estimasi reach: Custom',
      'Free 2–3 Desain + Caption',
      'Strategi & Konsultasi Prioritas',
      'A/B Testing & Optimasi Lanjutan',
      'Laporan Performa Real-time',
      'Dedicated Account Manager',
    ],
  },
];

const BONUS_STRIP = [
  { icon: LuGift, title: 'BONUS', subtitle: 'Setiap Paket' },
  { icon: LuUsers, title: 'FREE', subtitle: 'Konsultasi' },
  { icon: LuClipboardCheck, title: 'FREE', subtitle: 'Audit Akun Iklan' },
  { icon: LuTarget, title: 'FREE', subtitle: 'Rekomendasi Strategi' },
];

function PriceCard({ plan }) {
  // Pesan WhatsApp berdasarkan paket
  const getWAMessage = (packageName) => {
    const messages = {
      'Paket Siji': 'Halo%20SriDesain%2C%20saya%20tertarik%20dengan%20Paket%20Siji%20(%2FRp490.000)%20untuk%20Facebook%20%26%20Instagram%20Ads',
      'Paket Loro': 'Halo%20SriDesain%2C%20saya%20tertarik%20dengan%20Paket%20Loro%20(%2FRp990.000)%20untuk%20Facebook%20%26%20Instagram%20Ads',
      'Paket Telu': 'Halo%20SriDesain%2C%20saya%20tertarik%20dengan%20Paket%20Telu%20(%2FRp1.990.000)%20untuk%20Facebook%20%26%20Instagram%20Ads',
      'Paket Papat': 'Halo%20SriDesain%2C%20saya%20tertarik%20dengan%20Paket%20Papat%20(%2FRp5.000.000%2B)%20untuk%20Facebook%20%26%20Instagram%20Ads',
    };
    return messages[packageName] || 'Halo%20SriDesain%2C%20saya%20tertarik%20untuk%20konsultasi%20paket%20iklan';
  };

  return (
    <div
      className={`relative flex flex-col rounded-2xl border bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-lg ${
        plan.popular
          ? 'border-amber-400 shadow-amber-200/40 ring-1 ring-amber-400'
          : 'border-slate-100 shadow-slate-200/40'
      }`}
    >
      {plan.popular && (
        <span className="absolute -top-3 left-1/2 flex -translate-x-1/2 items-center gap-1 rounded-full bg-amber-400 px-3 py-1 text-[10px] font-bold uppercase tracking-wide text-[#0F172A] shadow-sm">
          <LuStar className="h-3 w-3 fill-[#0F172A]" /> Paling Populer
        </span>
      )}

      <h3 className="font-[var(--font-display)] text-lg font-bold text-[#0F172A]">
        {plan.name}
      </h3>
      <p className="mt-0.5 text-xs text-slate-500">{plan.subtitle}</p>

      <p className="mt-4 font-[var(--font-display)] text-2xl font-extrabold text-amber-600">
        {plan.price}
      </p>
      <p className="text-[11px] uppercase tracking-wide text-slate-400">Per bulan</p>

      <div className="mt-4 border-t border-dashed border-slate-200 pt-4" />

      <ul className="flex flex-1 flex-col gap-2.5">
        {plan.features.map((feat) => (
          <li key={feat} className="flex items-start gap-2 text-[13px] leading-snug text-slate-600">
            <span className="mt-1 h-1.5 w-1.5 shrink-0 rotate-45 bg-amber-400" />
            {feat}
          </li>
        ))}
      </ul>

       <a
        href={`https://wa.me/${WA_NUMBER}?text=${getWAMessage(plan.name)}`}
        target="_blank"
        rel="noopener noreferrer"
        className={`mt-6 flex items-center justify-center gap-1.5 rounded-xl border px-4 py-2.5 text-xs font-bold uppercase tracking-wide transition hover:scale-105 ${
          plan.popular
            ? 'border-amber-400 bg-amber-400 text-[#0F172A] hover:bg-amber-500'
            : 'border-slate-200 text-[#0F172A] hover:border-amber-300 hover:bg-amber-50'
        }`}
      >
        Pesan Sekarang <LuArrowRight className="h-3.5 w-3.5" />
      </a>
    </div>
  );
}

const Section9 = () => {
  const [activeTab, setActiveTab] = useState('meta');

  return (
    <section className="relative overflow-hidden bg-white py-16 lg:py-20">
      {/* Ambient glow, consistent with other sections */}
      <div className="pointer-events-none absolute -top-40 left-1/4 h-[600px] w-[600px] rounded-full bg-amber-100/60 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 right-0 h-[400px] w-[400px] rounded-full bg-slate-100/70 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        {/* Header row */}
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.4fr_1fr] lg:items-start">
          <div>
            <h2 className="font-[var(--font-display)] text-2xl font-bold leading-[1.15] tracking-tight text-[#0F172A] sm:text-3xl xl:text-4xl">
              Pilih Paket Iklan yang Sesuai dengan{' '}
              <span className="text-amber-600">Target Pertumbuhan Bisnis Anda</span>
            </h2>
            <div className="mt-3 h-1 w-16 rounded-full bg-amber-400" />
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-600 sm:text-base">
              Tingkatkan visibilitas, dapatkan lebih banyak leads, dan raih hasil
              maksimal bersama <span className="font-semibold text-amber-700">SriDesain.</span>
            </p>

            {/* Tabs */}
            <div className="mt-6 flex flex-wrap gap-3">
              {TABS.map(({ key, label, icon: Icon }) => {
                const active = activeTab === key;
                return (
                  <button
                    key={key}
                    onClick={() => setActiveTab(key)}
                    className={`flex items-center gap-2 rounded-xl border px-4 py-2.5 text-xs font-bold uppercase tracking-wide transition ${
                      active
                        ? 'border-amber-400 bg-amber-400 text-[#0F172A] shadow-sm shadow-amber-200/60'
                        : 'border-slate-200 text-slate-500 hover:border-amber-300 hover:text-[#0F172A]'
                    }`}
                  >
                    <Icon className="h-4 w-4" />
                    {label}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Performance overview card */}
          <div className="rounded-2xl border border-slate-100 bg-white p-5 shadow-lg shadow-slate-200/50">
            <p className="text-xs font-semibold text-[#0F172A]">Performance Overview</p>
            <div className="mt-3 grid grid-cols-3 gap-3">
              <div>
                <p className="text-[10px] text-slate-400">Reach</p>
                <p className="text-sm font-bold text-[#0F172A]">1.250.000</p>
                <p className="flex items-center gap-0.5 text-[10px] font-semibold text-green-600">
                  <LuArrowUpRight className="h-3 w-3" /> +156%
                </p>
              </div>
              <div>
                <p className="text-[10px] text-slate-400">Conversions</p>
                <p className="text-sm font-bold text-[#0F172A]">8.450</p>
                <p className="flex items-center gap-0.5 text-[10px] font-semibold text-green-600">
                  <LuArrowUpRight className="h-3 w-3" /> +198%
                </p>
              </div>
              <div>
                <p className="text-[10px] text-slate-400">Cost per Result</p>
                <p className="text-sm font-bold text-[#0F172A]">Rp 3.250</p>
                <p className="flex items-center gap-0.5 text-[10px] font-semibold text-green-600">
                  <LuArrowDownRight className="h-3 w-3" /> -32%
                </p>
              </div>
            </div>

            {/* mini sparkline + platform icons */}
            <div className="mt-4 flex items-center justify-between gap-3 border-t border-slate-100 pt-4">
              <svg viewBox="0 0 140 40" className="h-9 w-24">
                <polyline
                  fill="none"
                  stroke="#C9A227"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  points="0,32 15,28 30,30 45,20 60,22 75,14 90,16 105,8 120,10 140,2"
                />
              </svg>
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#1877F2]/10">
                  <FaFacebook className="h-4 w-4 text-[#1877F2]" />
                </span>
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-50">
                  <FaGoogle className="h-4 w-4 text-[#EA4335]" />
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Pricing cards */}
        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {PLANS.map((plan) => (
            <PriceCard key={plan.name} plan={plan} />
          ))}
        </div>

        {/* Bonus strip */}
        <div className="mt-10 grid grid-cols-1 gap-4 rounded-2xl border border-slate-100 bg-white px-6 py-5 shadow-sm shadow-slate-200/40 sm:grid-cols-2 lg:grid-cols-4">
          {BONUS_STRIP.map(({ icon: Icon, title, subtitle }) => (
            <div key={subtitle} className="flex items-center justify-center gap-3 sm:justify-start">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-amber-50 text-amber-600">
                <Icon className="h-5 w-5" />
              </span>
              <p className="leading-tight">
                <span className="block text-xs font-bold uppercase tracking-wide text-amber-600">
                  {title}
                </span>
                <span className="block text-sm font-semibold text-[#0F172A]">{subtitle}</span>
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Section9;